<template>
  <v-layout
    ref="objectForm"
    class="home-form-container elevation-2"
    column
    :style="{ right: sidebarIsOpen ? 300 - 95 + 'px' : '0' }"
  >
    <object-form-header
      :title="title"
      :sub-title="subTitle"
      :layer="layer"
      @close="$emit('close')"
    />

    <div style="height: 84%; overflow: auto;">
      <slot />
    </div>

    <object-form-footer
      v-if="objectUuid && layer"
      class="mx-15 mb-3 object-form-footer"
      :layer="layer"
      :object-uuid="objectUuid"
      :object-coordinate="objectCoordinates"
    />
  </v-layout>
</template>

<script>
import ObjectFormHeader from "@/components/Network/Forms/_Molecules/ObjectFormHeader";
import ObjectFormFooter from "@/components/Network/Forms/_Molecules/ObjectFormFooter";

export default {
  name: "ObjectFormStructure",
  components: {
    ObjectFormFooter,
    ObjectFormHeader
  },
  props: {
    /**
     * Title of the form.
     */
    title: {
      type: String,
      required: true
    },

    /**
     * SubTitle of the form.
     */
    subTitle: {
      type: String
    },

    /**
     * Layer of selected object
     */
    layer: {
      type: String,
      required: true
    },

    /**
     * UUID of selected object
     */
    objectUuid: {
      type: String,
      required: true
    },

    /**
     * Coordinate of selected object
     */
    objectCoordinate: {
      type: String,
      required: true
    }
  },

  computed: {
    /**
     * Determines whether the right sidebar is open or closed.
     * To define the position of the form
     * @returns {boolean}
     */
    sidebarIsOpen() {
      return !!this.$store.getters.getCurrentlyOpenTabSidebar;
    },

    objectCoordinates() {
      return JSON.parse(this.objectCoordinate);
    }
  }
};
</script>

<style scoped>
.home-form-container {
  height: 100%;
  width: 300px;
  position: absolute;
  background: white;
  border-radius: unset;
}
.object-form-footer {
  position: fixed;
  bottom: 0;
  z-index: 100;
}
</style>

<style>
#form-fields .v-expansion-panel-header {
  min-height: 27px;
  background: #f5f5f5;
  font: normal normal normal 12px/16px Segoe UI;
  padding-top: 0;
  padding-bottom: 0;
  text-transform: uppercase;
  color: #b1b6b9;
}

#form-fields .v-expansion-panel-header__icon {
  color: #b1b6b9;
}

#form-fields .v-expansion-panel:before {
  box-shadow: none;
}

#form-fields .v-expansion-panel-content__wrap {
  padding: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Network/Forms/_Templates/ObjectFormStructure.vue